import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { fetchCropVarieties } from '../cropVarietiesSlice';

export const useCropVarieties = () => {
  const dispatch = useDispatch();
  const { varieties, loading, error } = useSelector((state: RootState) => state.cropVarieties);

  useEffect(() => {
    dispatch(fetchCropVarieties());
  }, [dispatch]);

  return {
    varieties,
    loading,
    error
  };
};